<template>
  <div class="widget widget-section" :data-field="fieldName" :id="fieldName">
    <p :class="['label', subSection ? 'sub-label' : '' ]">{{ value }}</p>
    <p class="sub-label">{{ help }}</p>
  </div>
</template>

<script>
export default {
  name: 'section-widget',

  props: {
    model: {
      type: String,
      default: ''
    },
    fieldIndex: {
      type: String,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    },
    initialValue: {
      type: String,
      required: true
    },
    subSection: {
      type: Boolean,
      default: false
    },
    inlineHelp: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      value: '',
      help: ''
    }
  },

  mounted () {
    this.value = this.initialValue
    this.help = this.inlineHelp
  }
}
</script>

<style scoped>
  .label {
    font-weight: bold;
    font-size: 1.8em;
    color: #000;
    padding-left: 0px;
    white-space: normal;
  }

  .sub-label {
    font-size: 1.2em;
    padding-left: 0px;
    white-space: normal;
    /* margin: 10px; */
  }
</style>





// WEBPACK FOOTER //
// src/components/questionnaires/widgets/SectionWidget.vue